import { NgModule } from '@angular/core';
import { LatitudeUIProgressModule } from './progress/progress.module';
import { LatitudeUIGeoLogoMiniModule } from './geo-logo-mini/geo-logo-mini.module';
import { LatitudeUILoadingModule } from './loading/loading.module';
import { LatitudeUITimesliderModule } from './timeslider/timeslider.module';
import { ToggleUIProgressModule } from './toggle/toggle.module';

/**
 * Exported Modules
 * @type {Array}
 */
const modules = [
  LatitudeUIProgressModule,
  LatitudeUIGeoLogoMiniModule,
  LatitudeUILoadingModule,
  LatitudeUITimesliderModule,
  ToggleUIProgressModule
];

@NgModule({
  providers: [

  ],
  exports: [...modules],
  imports: [...modules]
})
export class LatitudeUIModule { }



// WEBPACK FOOTER //
// ./src/latitude-ui/latitude-ui.module.ts